<main>
  <section id="top" class="relative overflow-hidden pt-32 pb-16 lg:pt-40 lg:pb-24">
    <div
      class="pointer-events-none absolute -top-20 -left-24 w-[520px] h-[520px] rounded-full bg-indigo-300/25 blur-[120px]">
    </div>
    <div
      class="pointer-events-none absolute top-40 right-0 w-[460px] h-[460px] rounded-full bg-violet-300/20 blur-[120px]">
    </div>
    <div class="pointer-events-none absolute inset-0 opacity-[0.5] hero-bg-pattern">
    </div>
    <div class="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
      <div>
        <!-- Mobile Quick Nav Cards (Hidden on Desktop) -->
        <div class="mb-8 grid grid-cols-3 gap-2 sm:gap-3 md:hidden animate-[fade-in-up_0.8s_ease-out]">
          <a href="#jobs" class="mobile-nav-card mobile-nav-card--jobs">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </svg>
            <span>Jobs</span>
          </a>
          <a href="#assessments" class="mobile-nav-card mobile-nav-card--placement">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="m12 14 4-4" />
              <path d="M3.34 19a10 10 0 1 1 17.32 0" />
            </svg>
            <span class="leading-tight">Placement<br>Readiness</span>
          </a>
          <a href="#resume" class="mobile-nav-card mobile-nav-card--resume">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
              <path d="M14 2v4a2 2 0 0 0 2 2h4" />
              <path d="M10 9H8" />
              <path d="M16 13H8" />
              <path d="M16 17H8" />
            </svg>
            <span class="leading-tight">Resume<br>Builder</span>
          </a>
          <a href="#mock-interviews" class="mobile-nav-card mobile-nav-card--prep">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
              <rect x="2" y="6" width="14" height="12" rx="2" />
            </svg>
            <span class="leading-tight">AI Interview<br>Prep</span>
          </a>
          <a href="#assessments" class="mobile-nav-card mobile-nav-card--mock">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
              <path d="m9 14 2 2 4-4" />
            </svg>
            <span class="leading-tight">Mock<br>Tests</span>
          </a>
          <a href="#career-roadmap" class="mobile-nav-card mobile-nav-card--roadmap">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <path
                d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" />
              <path d="M15 5.764v15" />
              <path d="M9 3.236v15" />
            </svg>
            <span class="leading-tight">Career<br>Roadmap</span>
          </a>
        </div>
        <div
          class="inline-flex items-center gap-2 rounded-full border border-indigo-100 bg-indigo-50/80 px-3.5 py-1.5 text-xs font-semibold text-indigo-700"
          data-testid="hero-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-sparkles w-3.5 h-3.5" aria-hidden="true">
            <path
              d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z">
            </path>
            <path d="M20 3v4"></path>
            <path d="M22 5h-4"></path>
            <path d="M4 17v2"></path>
            <path d="M5 18H3"></path>
          </svg>AI-POWERED CAREER PLATFORM</div>
        <h1
          class="mt-6 font-display font-extrabold tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-[0.98] text-slate-900"
          data-testid="hero-heading"><span class="block overflow-hidden py-0.5"><span class="block"><span
                class="brand-gradient-text">Be</span><span class="text-slate-900">Expert</span></span></span><span
            class="block overflow-hidden py-0.5"><span class="block"><span class="brand-gradient-text">Get Hired
              </span><span class="">Faster.</span></span></span></h1>
        <p class="mt-6 max-w-xl text-base sm:text-lg text-slate-600 leading-relaxed">Everything you need to prepare &
          apply to jobs, build an ATS-ready resume, practice with AI mock interviews and mock tests, track your
          placement readiness, and apply with confidence.</p>

        <div class="mt-8 flex w-full items-center gap-2 sm:gap-3"><button data-testid="hero-google-cta" routerLink="/login"
            class="hero-btn-google flex-1 sm:flex-none">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-user-plus w-5 h-5 mr-2" aria-hidden="true">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <line x1="19" x2="19" y1="8" y2="14"></line>
              <line x1="22" x2="16" y1="11" y2="11"></line>
            </svg>
            Signup For Free</button><button data-testid="hero-email-cta" class="hero-btn-email flex-1 sm:flex-none" routerLink="/login">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-briefcase w-4 h-4 mr-2" aria-hidden="true">
              <rect width="20" height="14" x="2" y="7" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
            Apply For Jobs</button></div>

        <!-- Desktop Chips (Hidden on Mobile) -->
        <div class="hero-chips-container hidden md:flex"><span data-testid="hero-chip-ai-interviews"
            class="hero-chip"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-mic" aria-hidden="true">
              <path d="M12 19v3"></path>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
              <rect x="9" y="2" width="6" height="13" rx="3"></rect>
            </svg>AI Video Interviews</span><span data-testid="hero-chip-mock-tests" class="hero-chip"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-clipboard-list" aria-hidden="true">
              <rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
              <path d="M12 11h4"></path>
              <path d="M12 16h4"></path>
              <path d="M8 11h.01"></path>
              <path d="M8 16h.01"></path>
            </svg>Mock Tests</span><span data-testid="hero-chip-resume-builder" class="hero-chip"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-file-text" aria-hidden="true">
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
              <path d="M10 9H8"></path>
              <path d="M16 13H8"></path>
              <path d="M16 17H8"></path>
            </svg>ATS Resume Builder</span><span data-testid="hero-chip-one-click-apply" class="hero-chip"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-mouse-pointer-click" aria-hidden="true">
              <path d="M14 4.1 12 6"></path>
              <path d="m5.1 8-2.9-.8"></path>
              <path d="m6 12-1.9 2"></path>
              <path d="M7.2 2.2 8 5.1"></path>
              <path
                d="M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z">
              </path>
            </svg>One-Click Job Apply</span><span data-testid="hero-chip-career-roadmaps" class="hero-chip"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-map" aria-hidden="true">
              <path
                d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z">
              </path>
              <path d="M15 5.764v15"></path>
              <path d="M9 3.236v15"></path>
            </svg>Career Roadmaps</span><span data-testid="hero-chip-ats-resume" class="hero-chip"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-scan-line" aria-hidden="true">
              <path d="M3 7V5a2 2 0 0 1 2-2h2"></path>
              <path d="M17 3h2a2 2 0 0 1 2 2v2"></path>
              <path d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
              <path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
              <path d="M7 12h10"></path>
            </svg> Placement Readiness Score</span></div>
        <div class="mt-9 flex items-center gap-4">
          <div class="flex -space-x-3"><img alt="candidate"
              class="w-9 h-9 rounded-full border-2 border-white object-cover"
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&amp;h=80&amp;fit=crop&amp;q=80"><img
              alt="candidate" class="w-9 h-9 rounded-full border-2 border-white object-cover"
              src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&amp;h=80&amp;fit=crop&amp;q=80"><img
              alt="candidate" class="w-9 h-9 rounded-full border-2 border-white object-cover"
              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&amp;h=80&amp;fit=crop&amp;q=80"><img
              alt="candidate" class="w-9 h-9 rounded-full border-2 border-white object-cover"
              src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&amp;h=80&amp;fit=crop&amp;q=80">
          </div>
          <div>
            <div class="flex items-center gap-0.5"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="lucide lucide-star w-3.5 h-3.5 fill-amber-400 text-amber-400"
                aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-3.5 h-3.5 fill-amber-400 text-amber-400" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-3.5 h-3.5 fill-amber-400 text-amber-400" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-3.5 h-3.5 fill-amber-400 text-amber-400" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-3.5 h-3.5 fill-amber-400 text-amber-400" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><span class="ml-1.5 text-sm font-bold text-slate-900">Trusted by 2000+ Candidates</span></div>
            <p class="text-xs text-slate-500 mt-0.5">Students &amp; professionals across India</p>
          </div>
        </div>
      </div>
      <div class="relative order-2 lg:order-2 mt-8 lg:mt-0 hidden lg:block">
        <div class="pointer-events-none absolute inset-0 -m-6 rounded-[40px] bg-violet-300/20 blur-[80px]"></div>

        <!-- Main Card -->
        <div class="relative rounded-[2rem] bg-white border border-slate-100 p-4 md:p-6 shadow-xl">

          <!-- Top Section -->
          <div class="flex items-center justify-between mb-5 relative">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-violet-100 flex items-center justify-center">
                <svg class="w-5 h-5 md:w-6 md:h-6 text-violet-600" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z">
                  </path>
                </svg>
              </div>
              <div>
                <h3 class="font-bold text-slate-900 text-sm md:text-base">Placement Readiness Score</h3>
                <p class="text-xs text-slate-500 font-medium">Live evaluation · Updated today</p>
              </div>
            </div>
            <div class="flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 rounded-lg">
              <svg class="w-3.5 h-3.5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z">
                </path>
              </svg>
              <span class="text-[10px] md:text-xs font-bold text-indigo-600 hidden sm:inline">Powered by
                AI</span>
              <span class="text-[10px] md:text-xs font-bold text-indigo-600 sm:hidden">AI</span>
            </div>
          </div>

          <!-- Node Connection Graphic -->
          <div class="roadmap-graphic">
            <!-- Connecting line -->
            <div class="roadmap-connector desktop"></div>
            <div class="roadmap-connector mobile"></div>

            <!-- Node 1: Resume Analysis -->
            <div class="roadmap-node">
              <div class="roadmap-halo emerald">
                <div class="roadmap-inner-circle emerald">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                    </path>
                  </svg>
                </div>
              </div>
              <span class="roadmap-label">Resume<br>Analysis</span>
            </div>

            <!-- Node 2: Academic Profile -->
            <div class="roadmap-node">
              <div class="roadmap-halo blue">
                <div class="roadmap-inner-circle blue">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5z">
                    </path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z">
                    </path>
                  </svg>
                </div>
              </div>
              <span class="roadmap-label">Academic<br>Profile</span>
            </div>

            <!-- Node 3: AI Assessment -->
            <div class="roadmap-node">
              <div class="roadmap-halo emerald">
                <div class="roadmap-inner-circle emerald">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2">
                    </path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M9 13l2 2 4-4"></path>
                  </svg>
                </div>
              </div>
              <span class="roadmap-label">AI<br>Assessment</span>
            </div>

            <!-- Node 4: AI Mock Interview -->
            <div class="roadmap-node">
              <div class="roadmap-halo violet">
                <div class="roadmap-inner-circle violet">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z">
                    </path>
                  </svg>
                </div>
              </div>
              <span class="roadmap-label">AI Mock<br>Interview</span>
            </div>

            <!-- Node 5: Placement Readiness Score -->
            <div class="roadmap-node">
              <div class="roadmap-halo violet">
                <div class="roadmap-inner-circle deep-violet">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" stroke-width="2"></circle>
                    <circle cx="12" cy="12" r="6" stroke-width="2"></circle>
                    <circle cx="12" cy="12" r="2" stroke-width="2"></circle>
                  </svg>
                </div>
              </div>
              <span class="roadmap-label">Placement<br>Readiness Score</span>
            </div>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 items-center mb-4">
            <!-- Circular Progress -->
            <div class="flex flex-col items-center">
              <div class="relative w-28 h-28 flex items-center justify-center">
                <svg class="w-full h-full -rotate-90" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="40" fill="none" stroke="#f1f5f9" stroke-width="12"></circle>
                  <circle cx="50" cy="50" r="40" fill="none" stroke="url(#gradient-chart)" stroke-width="12"
                    stroke-dasharray="251.2" stroke-dashoffset="251.2" stroke-linecap="round"
                    class="animate-progress-circle" style="--target-offset: 40;">
                  </circle>
                  <defs>
                    <linearGradient id="gradient-chart" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stop-color="#8b5cf6"></stop>
                      <stop offset="100%" stop-color="#ec4899"></stop>
                    </linearGradient>
                  </defs>
                </svg>
                <div class="absolute inset-0 flex flex-col items-center justify-center text-center mt-1">
                  <span class="text-2xl font-bold text-slate-900 leading-none mb-0.5">84%</span>
                  <span class="text-[9px] font-bold text-slate-400 tracking-widest">READY</span>
                </div>
              </div>
              <div class="mt-4 px-2.5 py-1 bg-amber-50 border border-amber-100 rounded-full flex items-center gap-1.5">
                <svg class="w-3 h-3 text-amber-500 fill-amber-500" viewBox="0 0 20 20">
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
                  </path>
                </svg>
                <span class="text-[10px] font-bold text-amber-600">Rising Star - Top 15%</span>
              </div>
            </div>

            <!-- Breakdown -->
            <div class="w-full">
              <h4 class="text-[10px] font-bold tracking-widest text-slate-400 uppercase mb-2 text-center sm:text-left">
                Readiness Breakdown</h4>
              <div class="space-y-1.5 w-full">
                <div>
                  <div class="flex justify-between text-[10px] font-bold text-slate-700 mb-1">
                    <span>Technical Skills</span><span>92%</span>
                  </div>
                  <div class="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                    <div class="h-full bg-violet-500 rounded-full animate-progress-bar"
                      style="width: 0; --target-width: 92%"></div>
                  </div>
                </div>
                <div>
                  <div class="flex justify-between text-[10px] font-bold text-slate-700 mb-1">
                    <span>Communication</span><span>78%</span>
                  </div>
                  <div class="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                    <div class="h-full bg-cyan-500 rounded-full animate-progress-bar"
                      style="width: 0; --target-width: 78%"></div>
                  </div>
                </div>
                <div>
                  <div class="flex justify-between text-[10px] font-bold text-slate-700 mb-1">
                    <span>Problem Solving</span><span>88%</span>
                  </div>
                  <div class="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                    <div class="h-full bg-pink-500 rounded-full animate-progress-bar"
                      style="width: 0; --target-width: 88%"></div>
                  </div>
                </div>
                <div>
                  <div class="flex justify-between text-[10px] font-bold text-slate-700 mb-1">
                    <span>Confidence</span><span>82%</span>
                  </div>
                  <div class="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                    <div class="h-full bg-orange-500 rounded-full animate-progress-bar"
                      style="width: 0; --target-width: 82%"></div>
                  </div>
                </div>
                <div>
                  <div class="flex justify-between text-[10px] font-bold text-slate-700 mb-1">
                    <span>Resume Quality</span><span>95%</span>
                  </div>
                  <div class="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                    <div class="h-full bg-emerald-500 rounded-full animate-progress-bar"
                      style="width: 0; --target-width: 95%"></div>
                  </div>
                </div>
                <div>
                  <div class="flex justify-between text-[10px] font-bold text-slate-700 mb-1">
                    <span>Aptitude</span><span>90%</span>
                  </div>
                  <div class="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                    <div class="h-full bg-fuchsia-500 rounded-full animate-progress-bar"
                      style="width: 0; --target-width: 90%"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Recommendation -->
          <div class="bg-indigo-50/50 rounded-xl p-3 flex gap-3 items-start border border-indigo-50">
            <div class="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center shrink-0">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z">
                </path>
              </svg>
            </div>
            <div>
              <h4 class="text-[9px] font-bold text-indigo-600 tracking-widest uppercase mb-0.5">AI
                RECOMMENDATION</h4>
              <p class="text-[11px] text-slate-800 font-medium leading-tight mb-1">Improve <span
                  class="font-bold">communication skills</span> to increase your placement readiness by
                <span class="text-emerald-600 font-bold">+6%</span>.
              </p>
              <p class="text-[10px] text-slate-500">Suggested: Take one HR Mock Interview.</p>
            </div>
          </div>
        </div>

        <!-- Floating badges -->
        <div
          class="absolute -top-4 -left-4 md:-top-6 md:-left-6 bg-white rounded-xl p-2 md:p-3 shadow-lg shadow-slate-200/50 border border-slate-100 flex items-center gap-2.5 animate-[float_4s_ease-in-out_infinite]">
          <div class="w-6 h-6 md:w-8 md:h-8 rounded-full bg-emerald-500 flex items-center justify-center shrink-0">
            <svg class="w-3 h-3 md:w-4 md:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z">
              </path>
            </svg>
          </div>
          <div>
            <p class="text-[9px] md:text-[11px] font-bold text-slate-900 leading-tight">AI Analysis · Resume</p>
            <p class="text-[9px] md:text-[11px] font-bold text-emerald-600 leading-tight">Score 95%</p>
          </div>
        </div>

        <div
          class="absolute -top-2 -right-2 md:-top-4 md:-right-8 bg-white rounded-xl p-2 md:p-3 shadow-lg shadow-slate-200/50 border border-slate-100 flex items-center gap-2.5 animate-[float_5s_ease-in-out_infinite_reverse]">
          <div class="w-6 h-6 md:w-8 md:h-8 rounded-full bg-violet-500 flex items-center justify-center shrink-0">
            <svg class="w-3 h-3 md:w-4 md:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z">
              </path>
            </svg>
          </div>
          <div>
            <p class="text-[9px] md:text-[11px] font-bold text-slate-900 leading-tight">Interview Confidence</p>
            <p class="text-[9px] md:text-[11px] font-bold text-violet-600 leading-tight">Excellent · 92%</p>
          </div>
        </div>

        <div
          class="absolute -bottom-3 left-4 md:-bottom-4 md:left-4 bg-white rounded-xl p-2 md:p-3 shadow-lg shadow-slate-200/50 border border-slate-100 flex items-center gap-2.5 animate-[float_4.5s_ease-in-out_infinite_0.5s]">
          <div class="w-6 h-6 md:w-8 md:h-8 rounded-full bg-amber-500 flex items-center justify-center shrink-0">
            <svg class="w-3 h-3 md:w-4 md:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z">
              </path>
            </svg>
          </div>
          <div>
            <p class="text-[9px] md:text-[11px] font-bold text-slate-900 leading-tight">Communication</p>
            <p class="text-[9px] md:text-[11px] font-bold text-amber-600 leading-tight">+6% Potential</p>
          </div>
        </div>

        <div
          class="absolute -bottom-5 right-2 md:-bottom-6 md:right-4 bg-white rounded-xl p-2 md:p-3 shadow-lg shadow-slate-200/50 border border-slate-100 flex items-center gap-2.5 animate-[float_5.5s_ease-in-out_infinite_reverse]">
          <div class="w-6 h-6 md:w-8 md:h-8 rounded-full bg-blue-600 flex items-center justify-center shrink-0">
            <svg class="w-3 h-3 md:w-4 md:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6">
              </path>
            </svg>
          </div>
          <div>
            <p class="text-[9px] md:text-[11px] font-bold text-slate-900 leading-tight">ATS Resume</p>
            <p class="text-[9px] md:text-[11px] font-bold text-blue-600 leading-tight">96%</p>
          </div>
        </div>
      </div>
      <!-- Career Climb Animation -->
      <!-- @if (false) {
      <div class="climb-scene select-none hidden lg:block">

        <div class="climb-scene__orb climb-scene__orb--1"></div>
        <div class="climb-scene__orb climb-scene__orb--2"></div>

        <span *ngFor="let p of particles" class="climb-scene__particle" [style.width.px]="p.size"
          [style.height.px]="p.size" [style.left]="p.left" [style.top]="p.top" [style.background]="p.color"
          [style.animationDuration]="p.duration" [style.animationDelay]="p.delay">
        </span>

        <div *ngFor="let bar of bars" class="climb-scene__bar" [style.left]="bar.left" [style.height]="bar.height"
          [style.animationDelay]="bar.barDelay">
        </div>

        <div *ngFor="let bar of bars" class="climb-scene__card" [style.left]="bar.cardLeft"
          [style.bottom]="bar.cardBottom" [style.animationDelay]="bar.cardDelay">
          <span class="climb-scene__card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              @switch (bar.iconType) {
              @case ('profile') {
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <line x1="19" x2="19" y1="8" y2="14"></line>
              <line x1="22" x2="16" y1="11" y2="11"></line>
              }
              @case ('resume') {
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
              <path d="M10 9H8"></path>
              <path d="M16 13H8"></path>
              <path d="M16 17H8"></path>
              }
              @case ('test') {
              <rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
              <path d="M12 11h4"></path>
              <path d="M12 16h4"></path>
              <path d="M8 11h.01"></path>
              <path d="M8 16h.01"></path>
              }
              @case ('mic') {
              <path d="M12 19v3"></path>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
              <rect x="9" y="2" width="6" height="13" rx="3"></rect>
              }
              @case ('send') {
              <path
                d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z">
              </path>
              <path d="m21.854 2.147-10.94 10.939"></path>
              }
              @case ('check') {
              <path d="M20 6 9 17l-5-5"></path>
              }
              }
            </svg>
          </span>
          <span class="climb-scene__card-label">{{ bar.label }}</span>
        </div>

        <div *ngIf="isCelebrating" class="climb-scene__confetti-container">
          <span *ngFor="let c of confetti" class="climb-scene__confetti"
            [class.climb-scene__confetti--rect]="c.shape === 'rect'" [style.left]="c.left" [style.background]="c.color"
            [style.width.px]="c.size" [style.height.px]="c.size" [style.animationDuration]="c.duration"
            [style.animationDelay]="c.delay">
          </span>
        </div>

        <div class="climb-scene__character" [class.climb-scene__character--celebrating]="isCelebrating"
          [style.left]="characterLeft" [style.bottom]="characterBottom">

          @if (isCelebrating) {
          <div class="climb-scene__hired-badge">
            🎉 You're Hired!
          </div>
          }

          @if (isCelebrating) {
          <img src="/assets/images/character-female-celebrate.png" alt="BeExpert candidate celebrating getting hired"
            draggable="false" class="climb-scene__character-img climb-scene__character-img--celebrate" />
          } @else {
          <img src="/assets/images/character-female-walk.png" alt="BeExpert candidate climbing the career journey"
            draggable="false" class="climb-scene__character-img" />
          }
        </div>

      </div>
      } -->
    </div>
  </section>
</main>